import styled from 'styled-components';

export const Label = styled.span`
  display: block;

  overflow: hidden;

  text-overflow: ellipsis;
  white-space: nowrap;
`;
